import { render, staticRenderFns } from "./TabPaneSquare.vue?vue&type=template&id=1bedb500&"
import script from "./TabPaneSquare.vue?vue&type=script&lang=js&"
export * from "./TabPaneSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports